const flags = [
  ['#E40303', '#FF8C00', '#FFED00', '#008026', '#004CFF', '#732982'],
  ['#5BCFFB', '#F5ABB9', '#FFFFFF', '#F5ABB9', '#5BCFFB'],
  ['#D62800', '#FF9B56', '#FFFFFF', '#D462A6', '#A40062'],
  ['#D60270', '#9B4F96', '#0038A8'],
];

export const randomFlag = (seed: string) => {
  const enc = new TextEncoder();
  const val = ((enc.encode(seed).at(1) || 0) % flags.length) + 1;

  const flag = flags[val - 1];
  const bands = flag.length;

  const svg = `data:image/svg+xml;base64,${btoa(`<svg version="1.1"
     baseProfile="full"
     xmlns="http://www.w3.org/2000/svg"
     xmlns:xlink="http://www.w3.org/1999/xlink"
     xmlns:ev="http://www.w3.org/2001/xml-events" width="${bands}px" height="${bands}px" viewBox="0 0 ${bands} ${bands}">
    ${Array.from({ length: bands }, () => '')
      .map(
        (_, i) =>
          `<rect width="${bands}px" height="1px" x="0" y="${i}px" fill="${flag[i]}"></rect>`,
      )
      .join('')}
  </svg>`)}`;

  console.log(svg);

  return svg;
};
